<template>
  <div>
    <div id="app">
      <div class="app-cover">
        <header id="header">
            <div id="headerContainer">
                <div id="hLogo">
                    <router-link :to="'/'+language"><img src="@/assets/logo.jpg" alt="Logo ecom4children"></router-link>
                </div>
                <div class="d-flex width-100 ml-auto">
                  <router-link class="mt-auto mb-auto ml-auto mr-3" :to="'/'+language+'/after-buying-online'">
                    <md-button class="button md-primary">
                      <font-awesome-icon class="mr-1" icon="lightbulb" />
                      {{ $t('after_buying_title') }}
                    </md-button>
                  </router-link>
                  <div id="hLanguage">
                    <md-field>
                      <md-select v-model="language" name="language" id="language" :placeholder="language.toUpperCase()" @md-selected="changeLanguage()">
                        <md-option value="en"><span class="flag-icon flag-icon-en"></span> EN</md-option>
                        <md-option value="es"><span class="flag-icon flag-icon-es"></span> ES</md-option>
                        <md-option value="pt"><span class="flag-icon flag-icon-pt"></span> PT</md-option>
                        <md-option value="it"><span class="flag-icon flag-icon-it"></span> IT</md-option>
                        <md-option value="cz"><span class="flag-icon flag-icon-cz"></span> CZ</md-option>
                      </md-select>
                    </md-field>
                  </div>
                </div>
            </div>
        </header>
        <router-view id="container" :key="$route.fullPath" />
      </div>
    </div>
    <footer>
        <div class="info">
          <p class="m-0">
            {{ $t('home_note2') }}
            <a :href="'https://www.ecom4children.eu/'+slug" target="blank">ecom4children.eu</a>.
          </p>
          <p class="mt-1 mb-2" v-html="$t('cc_message')"></p>
          <img src="@/assets/by-nc-nd.png" alt="Creative commons license" style="height:30px !important"/>
        </div>
        <div class="disclaimer">
          <div class="col-12 col-md-4 d-flex"><img class="mt-auto mb-auto ml-auto" :src="require('@/assets/commision-'+language+'.jpg')"></div>
          <p class="col-12 col-md-8 text-left" v-html="$t('disclaimer_text')"></p>
        </div>
    </footer>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';
import { LANGUAGES } from '@/config';

export default {
  data() {
    return {
      language: 'en',
      slug: ''
    }
  },
  created() {
    let lang = this.$route.params.locale;
    if (LANGUAGES.includes(lang)) {
      i18n.locale = lang;
      this.language = lang;
    } else {
      this.$router.push('/');
    }
    switch (i18n.locale) {
        case 'es':
            this.slug = 'es';
            break;
        case 'pt':
            this.slug = 'pt-pt';
            break;
        case 'it':
            this.slug = 'it';
            break;
        case 'cz':
            this.slug = 'cs';
            break;
    }
  },
  mounted() {
    var elem = document.getElementsByClassName("md-menu")[0];
    var span = document.createElement("span");
    span.setAttribute("id", "staticFlag");
    span.setAttribute("class", "ml-2 flag-icon flag-icon-"+i18n.locale);
    elem.prepend(span);
  },
  watch: {
    '$route.params.locale': function (newLocale, oldLocale) {
      if (oldLocale != newLocale) {
        if (LANGUAGES.includes(newLocale)) {
          i18n.locale = newLocale;
        } else {
          this.$router.push('/');
        } 
      }
    }
  },
  methods: {
    changeLanguage() {
      var staticFlag = document.getElementById("staticFlag");
      staticFlag.classList.remove("flag-icon-"+i18n.locale);
      staticFlag.classList.add("flag-icon-"+this.language);
      this.$router.push(this.$router.history.current.path.replace('/'+i18n.locale, '/'+this.language));

    }
  }
}
</script>

<style lang="scss">
  @import "node_modules/bootstrap/scss/functions";
  @import "node_modules/bootstrap/scss/variables";
  @import "node_modules/bootstrap/scss/mixins/_breakpoints";

  body {
    background-image: url('./assets/memphis-colorful.png');
    #app {
      background-color: rgba(255, 255, 255, 0.6);
      .app-cover {
        background-color: rgba(0, 0, 0, 0.05);
        min-height: calc(100vh - 200px);
      }
    }
    #header {
      // position: fixed;
      width: 100%;
      height: 70px;
      top: 0;
      background-color: #fff;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.5);
      z-index: 10;
      #headerContainer {
        display: flex;
        height: 100%;
        #hLogo {
          margin: auto 0;
          margin-left: 50px;
          img {
            height: 45px;
          }
        }
        #hLanguage {
          margin: 0 0 0 auto;
          margin-right: 80px;
          width: 100px;
        }
        @include media-breakpoint-down(sm) {
          #hLogo {
            margin-left: 20px;
            img {
              height: 35px;
            }
          }
          #hLanguage {
            margin-right: 30px;
          }
        }
      }
    }
    #container {
      padding: 0 10px 40px 10px;
      p.h2 {
        font-size: 2.1rem;
      }
      @include media-breakpoint-down(md) {
        p.h2 {
          font-size: 2rem;
        }
      }
      @include media-breakpoint-down(sm) {
        p.h2 {
          font-size: 1.9rem;
        }
      }
      @include media-breakpoint-down(xs) {
        p.h2 {
          font-size: 1.7rem;
        }
      }
    }
  }
  .md-list-item-text {
    flex-direction: row !important;
    flex: initial !important;
  }
  .md-select-menu {
    width: 150px !important;
  }
  .md-menu {
    ::placeholder {
      color: rgba(0,0,0,0.87) !important;
    }
  }
  .md-field.md-theme-default:before {
    background-color: #e31b18 !important;
  }
  .flag-icon {
    background-size: contain;
    background-position: 50%;
    background-repeat: no-repeat;
    position: relative;
    display: inline-block;
    width: 1.33333333em !important;
    line-height: 1em;
    margin-right: 5px !important;
    &:before {
      content: "\00a0";
    }
    &-en {
      background-image: url('./assets/gb.svg');
    }
    &-es {
      background-image: url('./assets/es.svg');
    }
    &-pt {
      background-image: url('./assets/pt.svg');
    }
    &-it {
      background-image: url('./assets/it.svg');
    }
    &-cz {
      background-image: url('./assets/cz.svg');
    }
  }

  footer {
    text-align: center;
    color: white;
    background-color: #630C0A;
    .info {
      padding: 30px 10px;
      margin: 0;
    }
    .disclaimer {
      padding: 10px 10%;
      background: white;
      text-align: center;
      margin: auto;
      display: flex;
      img {
        width: 100%;
        max-width: 250px;
        max-height: 85px;
      }
      p {
        margin-top: 10px;
        color: gray;
      }
      @include media-breakpoint-down(sm) {
        display: block;
        padding: 10px;
        img {
          max-width: 200px;
          margin: auto;
        }
        p {
          text-align: center !important;
          padding: 10px;
          margin: 0px;
        }
      }
    }
  }

  .md-button.md-primary {
    background-color: #e31b18;
    color: white !important;
    &:hover, &:focus {
      background-color: #BF1714;
    }
    &:disabled {
      background-color: gray;
    }
  }

  .btn-outline-primary {
    border-color: #e31b18;
    color: #e31b18;
    &:hover, &:focus {
      background-color: #BF1714;
      border-color: #BF1714
    }
  }

  .btn-primary {
    background-color: #e31b18;
    border-color: #e31b18;
    &:hover, &:focus {
      background-color: #BF1714;
      border-color: #BF1714
    }
  }

  @include media-breakpoint-down(md) {
    .underline {
      max-width: 250px !important;
    }
  }
  @include media-breakpoint-down(sm) {
    .underline {
      max-width: 200px !important;
    }
  }
  @include media-breakpoint-down(xs) {
    .underline {
      max-width: 150px !important;
    }
  }
</style>
